import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import * as fromApp from "../store/app.reducer";
import { first } from "rxjs";
import { DataStorageService } from "./data-storage/data-storage.service";
import * as GroupAppActions from "../store/group-app/groupApp.actions";
import * as AuthActions from "../auth/store/auth.actions";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class UposUserValidationServiceService {
  constructor(
    private router: Router,
    private store: Store<fromApp.AppState>,
    private dataStorageService: DataStorageService
  ) {}

  public handleGroupAppForUposUser(action, currentUser, do_not_navigate) {
    if (action === "login") {
      this.store
        .select("groupApp")
        .pipe(first())
        .subscribe((state) => {
          if (
            state &&
            state.groupApp &&
            currentUser &&
            currentUser.uposMoUser
          ) {
            const groupApp = _.cloneDeep(state.groupApp);

            if (groupApp.pointsSystem) {
              groupApp.pointsSystem = false;
            }

            if (groupApp.affiliateActive) {
              groupApp.affiliateActive = false;
            }

            this.store.dispatch(
              new GroupAppActions.SetGroupApp(_.cloneDeep(groupApp))
            );
          }
        })
        .unsubscribe();
    } else if (action === "logout") {
      this.store
        .select("groupApp")
        .pipe(first())
        .subscribe((state) => {
          if (
            state &&
            state.groupApp &&
            currentUser &&
            currentUser.uposMoUser
          ) {
            this.dataStorageService
              .fetchGroupApp(state.groupApp.group)
              .subscribe({
                next: (res: any) => {
                  const groupApp = _.cloneDeep(res);
                  this.store.dispatch(new AuthActions.ClearUser());
                  this.store.dispatch(
                    new GroupAppActions.SetGroupApp(_.cloneDeep(groupApp))
                  );
                  if (!do_not_navigate) {
                    this.router.navigateByUrl("/homepage", {
                      replaceUrl: true,
                    });
                  }
                },
                error: (err) => {
                  location.reload();
                },
              });
          }
        });
    }
  }
}
